import React from "react";
import { Link } from "react-router-dom";

const Unauthorized: React.FC = () => {
  return (
    <div>
      <h1>403 - Unauthorized</h1>
      <p>You do not have access to this page.</p>
      <Link to="/">Go to Login</Link>
    </div>
  );
};

export default Unauthorized;
